import React from "react";
import aboutUs from "../../PicesForPages/AboutUs.jpg";
import FreeConsultation from "../Form/FreeConsultation";
import { Link } from "react-router-dom";

function AboutUs() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent aboutUsTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={aboutUs}
          alt="aboutUsImage"
          className="background-video aboutUsImagedp"
        />
        <div className="purchasetopBox aboutUsTopBox">
          {/* The existing Purchase span */}
          <span>About Us</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              At Prime Home Mortgage, INC, we see each client as a unique
              individual rather than just another statistic. We don’t rely on
              the one-size-fits-all loan formulas typically used by banks.
              Instead, we apply practical, "common sense" to help you secure the
              best possible loan. We work with a diverse range of highly rated
              lenders, offering everything from competitive rates to specialized
              private lenders for more challenging situations.
            </span>
            <span className="purchaseBottomLeftContent">
              With over 100 investors on our roster, we’re able to offer you the
              best rates across a variety of loan options, including: 30-year
              mortgages, 20-year mortgages, 15-year mortgages, 10-year
              mortgages, 1-year ARMs, 3-year ARMs, 5-year ARMs, Conventional
              loans, Jumbo loans, Home Equity Lines, VA loans, and Commercial
              loans. Whether you need Full Documentation, No Documentation,
              Non-Owner Occupied (Investor) properties, or Multi-Family
              solutions, we have the right option for you!
            </span>

            <br />
            <br />
            <br />
            <div className="purchaseBottomLeftButton">
              <Link to="#" className="purchaseBottomLeftButtonLink">
                APPLY NOW!
              </Link>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
